import {ReceiptExpensesType, SiteTargetType} from "@/enums/type";
import {DebtEmployeeStatus, DebtPostOfficeStatus} from "@/enums/status";

export class ExpensePostOfficeParams {
    page = 1;
    limit = 10;
    postOfficeRowGuid?: string;
    type = ReceiptExpensesType.PickingListPay;
    status = DebtPostOfficeStatus.NotYetCollect;
    revenueExpenditureId?: number;
}
